import { apiSalesWeb } from '@shared/config';

export interface ICreateCheckoutOutput {
  id: string;
}

export function createCheckout() {
  return apiSalesWeb.post<ICreateCheckoutOutput>('/checkout');
}
